export default __webpack_public_path__ + "static/media/f_logo_text_btm.64e5793d.png";